<template>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="nav-inner">
          <nav class="navbar navbar-expand-lg">
            <router-link to="/" class="navbar-brand">
              <img src="/assets/img/icon/logo-vertical.png" alt="Logo">
            </router-link>
            <button id="toggle" class="navbar-toggler mobile-menu-btn" type="button" data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
              aria-label="Toggle navigation">
              <span class="toggler-icon"></span>
              <span class="toggler-icon"></span>
              <span class="toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
              <ul id="nav" class="navbar-nav ms-auto">
                <li class="nav-item active" v-on:click="collapseNavbar">
                  <router-link to="/">Home</router-link>
                </li>
                <li class="nav-item" v-on:click="collapseNavbar">
                  <router-link to="/about">About Tribinnov</router-link>
                </li>
                <li class="nav-item" v-on:click="collapseNavbar">
                  <router-link to="/how-we-work">How We Work</router-link>
                </li>
                <li class="nav-item" v-on:click="collapseNavbar">
                  <router-link to="/focus">Focus Area</router-link>
                </li>
                <li class="nav-item" v-on:click="collapseNavbar">
                  <router-link to="/team">Our Team</router-link>
                </li>
                <!-- <li class="nav-item">
                  <router-link to="/community">Visit Community</router-link>
                </li> -->
                <li class="nav-item" v-on:click="collapseNavbar">
                  <a href="https://blog.tribinnovafrica.com" target="_blank">Blog</a>
                </li>
                <li class="nav-item" v-on:click="collapseNavbar">
                  <a href="https://blog.tribinnovafrica.com/categories/news-and-update" target="_blank">News & Update</a>
                </li>
                <!-- <li class="nav-item" v-on:click="collapseNavbar">
                  <router-link to="/#">Careers</router-link>
                </li> -->
                <!-- <li class="nav-item" v-on:click="collapseNavbar">
                  <router-link to="/#">Partners</router-link>
                </li> -->
                <!-- <li class="nav-item">
                  <a class="page-scroll dd-menu collapsed" href="javascript:void(0)" data-bs-toggle="collapse"
                    data-bs-target="#submenu-1-4" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">Pages</a>
                  <ul class="sub-menu collapse" id="submenu-1-4">
                    <li class="nav-item"><a href="about-us.html">About Us</a></li>
                  </ul>
                </li> -->
              </ul>
            </div> <!-- navbar collapse -->
          </nav> <!-- navbar -->
        </div>
      </div>
    </div> <!-- row -->
  </div> <!-- container -->
</template>

<script>
  export default {
    name: 'Navbar',
    methods: {
      collapseNavbar() {
        let element = document.getElementById('toggle')
        let element2 = document.getElementById('navbarSupportedContent')
        element.classList.remove('active')
        element.classList.add('collapsed')
        element2.classList.remove('show')
      }
    }
  }
</script>
